import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import { ImpersonationMode } from "@/components/ImpersonationMode";
import { initSentry } from "@/lib/sentry";

// Initialize Sentry for error tracking
initSentry();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ErrorBoundary>
      <ImpersonationMode />
      <App />
    </ErrorBoundary>
  </StrictMode>
);
